var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPVendorMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.625C11.1723 0.629516 7.50273 2.15206 4.79615 4.85863C2.08957 7.56521 0.567031 11.2348 0.562515 15.0625C0.557931 18.1905 1.57968 21.2336 3.47102 23.725C3.47102 23.725 3.86477 24.2434 3.92908 24.3183L15 37.375L26.0762 24.3117C26.134 24.2421 26.529 23.725 26.529 23.725L26.5303 23.7211C28.4207 21.2307 29.442 18.189 29.4375 15.0625C29.433 11.2348 27.9105 7.56521 25.2039 4.85863C22.4973 2.15206 18.8277 0.629516 15 0.625ZM15 20.3125C13.9617 20.3125 12.9466 20.0046 12.0833 19.4277C11.2199 18.8508 10.547 18.0309 10.1496 17.0716C9.75229 16.1123 9.64832 15.0567 9.85089 14.0383C10.0535 13.0199 10.5535 12.0844 11.2877 11.3502C12.0219 10.616 12.9574 10.1159 13.9758 9.91338C14.9942 9.7108 16.0498 9.81477 17.0091 10.2121C17.9684 10.6095 18.7884 11.2824 19.3652 12.1458C19.9421 13.0091 20.25 14.0241 20.25 15.0625C20.2483 16.4544 19.6946 17.7887 18.7104 18.7729C17.7262 19.7571 16.3919 20.3108 15 20.3125Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPVendorMap);
export default __webpack_public_path__ + "static/media/p_vendor_map.c45ebe22d0ecbf5a2652eed13614f642.svg";
export { ForwardRef as ReactComponent };